import React from 'react';

import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import {
    Layout, Menu, Breadcrumb, Icon,Card,
  } from 'antd';
import '../../assets/css/App.css';
import routes from '../../model/router';
import Header1 from '../public';
import Background from "../../assets/images/background.jpg";

const {
    Header, Content, Footer, Sider,
  } = Layout;
const SubMenu = Menu.SubMenu;
const { Meta } = Card;

class BlindedReview extends React.Component{
    constructor(props){
        super(props);
        this.state={

        }
    }
    render(){
        return(
            <div>
              <Header1></Header1>
            <Content style={{ padding: '0 50px' }}>

              <Layout style={{background: '#fff' }}>
                <Sider width={200} style={{ background: '#fff' }}>
                  <Menu
                    mode="inline"
                    defaultSelectedKeys={['1']}
                    defaultOpenKeys={['sub1']}
                    style={{ height: '100%' }}
                  >
                   <SubMenu key="sub1" title={<span><Icon type="user" />Review</span>}>
                      <Menu.Item key="1"><Link to="/BlindedReview">Anonymous</Link></Menu.Item>
                    
                    </SubMenu>

                  </Menu>
                </Sider>
                <Content style={{ padding: '0 50px' }}>

                    <div style={{background: `url(${Background}) no-repeat center center`,height:300, width: "100%",backgroundSize: "cover",}}>
                    <div style={{textAlign:"center"}}>
                    <br></br>

                    <txt style={{fontSize:30,fontWeight:'bold',}}>The study involved in this platform is currently under a double-blind review process, and we are sorry that we cannot disclose the platform owner in this stage. This page will be open at the end of the double-blind review. All the visiting of this platform will not be affected during this process.</txt>
                    </div>
                    </div>
                </Content>
                    </Layout>
            </Content>
            </div>
        )
    }
}
export default BlindedReview;